import { render, staticRenderFns } from "./empList.vue?vue&type=template&id=677f49a6&scoped=true&"
import script from "./empList.vue?vue&type=script&lang=js&"
export * from "./empList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f49a6",
  null
  
)

export default component.exports